'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useAppDispatch } from '@akinon/next/redux/hooks';
import { resetHeaderState } from '@akinon/next/redux/reducers/header';
import { closeMiniBasket } from '@akinon/next/redux/reducers/root';
import { ROUTES } from '@theme/routes';
import { GoogleTagManager } from '@next/third-parties/google';
import { pushPageView } from '@theme/utils/gtm';
import { pcPageView } from '@theme/utils/personaclick';
import Script from 'next/script';

export default function RootTemplate({
  children
}: {
  children: React.ReactNode;
}) {
  const dispatch = useAppDispatch();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const URL = process.env.NEXT_PUBLIC_URL;
  const currentUrl = URL + pathname + searchParams;

  useEffect(() => {
    dispatch(closeMiniBasket());
    dispatch(resetHeaderState());
  }, [dispatch, pathname, searchParams]);

  useEffect(() => {
    if (pathname === ROUTES.HOME) {
      window.scrollTo(0, 0);
    }
    pushPageView({ url: currentUrl });
    pcPageView({ url: currentUrl });
  }, [pathname]);

  const isHome = pathname === ROUTES.HOME || pathname === '/';

  const jsonLdOrganization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Yatsan',
    alternateName: "Yatsan",
    url: currentUrl,
    logo: `${URL}/logo.svg`,
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+90-444-35-99',
        contactType: 'customer service',
        availableLanguage: ['Turkish'],
        areaServed: 'TR'
      }
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Kazım Karabekir Mahallesi, Bekir Saydam Caddesi, Pancar Organize Sanayi Bölgesi No:80',
      addressLocality: 'Torbalı',
      addressRegion: 'İzmir',
      postalCode: "35860",
      addressCountry: 'TR'
    },
    foundingDate: "1974",
    sameAs: [
      'https://www.facebook.com/yatsanyatak',
      'https://x.com/yatsanyatak',
      'https://www.instagram.com/yatsanyatak/',
      'https://www.youtube.com/c/yatsantr',
      'https://www.linkedin.com/company/yatsan'
    ]
  };

  return (
    <>
      {/* Google Tag Manager */}
      <GoogleTagManager gtmId={'GTM-T2ZR77'} />
      {/* End Google Tag Manager */}
      {isHome && (
        <Script id="schema-organization" data-script-organization-schema type="application/ld+json" strategy="beforeInteractive">
          {JSON.stringify(jsonLdOrganization)}
        </Script>
      )}
      {children}
    </>
  );
}
